import PropTypes from "prop-types";

export default {
	rating: PropTypes.number,
	size: PropTypes.number,
	space: PropTypes.number,
	showLabel: PropTypes.bool,
};
